// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    height: 100%;
    margin: 0;
    font-family: Arial, sans-serif;
  }
  
  .UserManagementPage {
    display: flex;
    align-items: center;
    height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    flex-direction: column;
  }
  
  .card {
    background: white;
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-self: center;
    margin: 10px;
    word-wrap: break-word;
  }
  
  .logo {
    width: 220px;
    height: 120px;
    object-fit: contain;
    margin: 10px;
  }
  
  .user-list, .edit-user, .add-user {
    margin: 20px 0;
  }
  
  .user-list ul {
    list-style-type: none;
    padding: 0;
  }
  
  .user-list li {
    cursor: pointer;
    padding: 10px;
    background-color: rgb(224, 224, 224);
    margin: 5px 0;
    border-radius: 5px;
  }
  
  .user-list li:hover {
    background-color: rgb(204, 204, 204);
  }
  
  label {
    display: block;
    margin-bottom: 10px;
  }
  
  input {
    padding: 5px;
    margin-top: 5px;
    width: 100%;
    box-sizing: border-box;
  }
  
  button {
    margin-top: 10px;
    padding: 10px 20px;
    border: none;
    background-color: #4CAF50;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }
  
  button:hover {
    background-color: #45a049;
  }
  
  @media (max-width: 599px) {
    .card {
      padding: 20px;
    }
    p {
      font-size: 12px;
    }
    img {
      width: 20px;
      height: 20px;
    }
    h1 {
      font-size: 18px;
    }
  }
  
  @media (min-width: 600px) and (max-width: 899px) {
    .card {
      padding: 30px;
    }
    p {
      font-size: 15px;
    }
    img {
      width: 25px;
      height: 25px;
    }
    h1 {
      font-size: 20px;
    }
  }
  
  @media (min-width: 900px) {
    .card {
      padding: 40px;
    }
    p {
      font-size: 16px;
    }
    img {
      width: 30px;
      height: 30px;
    }
    h1 {
      font-size: 22px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/UserManagementPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,yDAAoD;IACpD,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,eAAe;IACjB;EACF","sourcesContent":["body, html {\n    height: 100%;\n    margin: 0;\n    font-family: Arial, sans-serif;\n  }\n  \n  .UserManagementPage {\n    display: flex;\n    align-items: center;\n    height: 100vh;\n    background-image: url('../../assets/background.jpg');\n    background-size: cover;\n    background-position: center;\n    flex-direction: column;\n  }\n  \n  .card {\n    background: white;\n    padding: 30px;\n    border-radius: 15px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    flex-direction: column;\n    align-self: center;\n    margin: 10px;\n    word-wrap: break-word;\n  }\n  \n  .logo {\n    width: 220px;\n    height: 120px;\n    object-fit: contain;\n    margin: 10px;\n  }\n  \n  .user-list, .edit-user, .add-user {\n    margin: 20px 0;\n  }\n  \n  .user-list ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .user-list li {\n    cursor: pointer;\n    padding: 10px;\n    background-color: rgb(224, 224, 224);\n    margin: 5px 0;\n    border-radius: 5px;\n  }\n  \n  .user-list li:hover {\n    background-color: rgb(204, 204, 204);\n  }\n  \n  label {\n    display: block;\n    margin-bottom: 10px;\n  }\n  \n  input {\n    padding: 5px;\n    margin-top: 5px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  button {\n    margin-top: 10px;\n    padding: 10px 20px;\n    border: none;\n    background-color: #4CAF50;\n    color: white;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  \n  button:hover {\n    background-color: #45a049;\n  }\n  \n  @media (max-width: 599px) {\n    .card {\n      padding: 20px;\n    }\n    p {\n      font-size: 12px;\n    }\n    img {\n      width: 20px;\n      height: 20px;\n    }\n    h1 {\n      font-size: 18px;\n    }\n  }\n  \n  @media (min-width: 600px) and (max-width: 899px) {\n    .card {\n      padding: 30px;\n    }\n    p {\n      font-size: 15px;\n    }\n    img {\n      width: 25px;\n      height: 25px;\n    }\n    h1 {\n      font-size: 20px;\n    }\n  }\n  \n  @media (min-width: 900px) {\n    .card {\n      padding: 40px;\n    }\n    p {\n      font-size: 16px;\n    }\n    img {\n      width: 30px;\n      height: 30px;\n    }\n    h1 {\n      font-size: 22px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
